module.exports = __webpack_public_path__ + "static/dashboard-f3b1a05154e4d96a6a54989090e2a53b.svg";